import { Proposal, ProposalState } from "@solana/spl-governance";
import {
  BLUE_COLOR,
  BLUE_TEXT_COLOR,
  GREEN_COLOR,
  GREEN_TEXT_COLOR,
  RED_COLOR,
  RED_TEXT_COLOR,
} from "../../../../common/constants/common.constants";
import {
  OfferStatus,
  ProposalAction,
} from "../../../../common/enums/proposals.enums";

export function getProposalStatusColorFromSolana(
  status: ProposalState,
  proposalAction: ProposalAction,
  offerStatus?: OfferStatus,
  hasNftSold?: boolean
): string {
  switch (status) {
    case ProposalState.Completed:
      if (
        proposalAction === ProposalAction.Transfer ||
        proposalAction === ProposalAction.Withdrawal ||
        hasNftSold
      ) {
        return GREEN_TEXT_COLOR;
      }
      return offerStatus === OfferStatus.initialised ||
        (offerStatus === OfferStatus.listedOnSolsea &&
          proposalAction === ProposalAction.SellNft)
        ? BLUE_TEXT_COLOR
        : offerStatus === OfferStatus.initializeOnMe &&
          proposalAction === ProposalAction.BuyNft
        ? RED_TEXT_COLOR
        : offerStatus === OfferStatus.accepted ||
          offerStatus === OfferStatus.pendingBuyNowExecutionOnMagicEden ||
          offerStatus === OfferStatus.pendingSellExecutionOnMagicEden ||
          offerStatus === OfferStatus.executedSellOnMagicEden ||
          !offerStatus
        ? GREEN_TEXT_COLOR
        : RED_TEXT_COLOR;
    case ProposalState.Succeeded:
    case ProposalState.Executing:
      return GREEN_TEXT_COLOR;
    case ProposalState.Cancelled:
    case ProposalState.Defeated:
    case ProposalState.ExecutingWithErrors:
      return RED_TEXT_COLOR;
    case ProposalState.Voting:
    case ProposalState.SigningOff:
    case ProposalState.Draft:
      return BLUE_TEXT_COLOR;
    default:
      return "white";
  }
}

export function getProposalStatusBackgroundColorFromSolana(
  status: ProposalState,
  offerStatus: OfferStatus,
  proposalAction: ProposalAction,
  hasNftSold?: boolean
): string {
  switch (status) {
    case ProposalState.Voting:
      return BLUE_COLOR;
    case ProposalState.Completed:
      if (
        proposalAction === ProposalAction.Transfer ||
        proposalAction === ProposalAction.Withdrawal ||
        hasNftSold
      ) {
        return GREEN_COLOR;
      }
      return offerStatus === OfferStatus.initialised ||
        (offerStatus === OfferStatus.listedOnSolsea &&
          proposalAction === ProposalAction.SellNft)
        ? BLUE_COLOR
        : offerStatus === OfferStatus.initializeOnMe &&
          proposalAction === ProposalAction.BuyNft
        ? RED_COLOR
        : offerStatus === OfferStatus.accepted ||
          offerStatus === OfferStatus.executedSellOnMagicEden
        ? GREEN_COLOR
        : offerStatus === OfferStatus.canceled ||
          offerStatus === OfferStatus.canceledOnMagic ||
          offerStatus === OfferStatus.canceledOnSolsea
        ? RED_COLOR
        : GREEN_COLOR;
    case ProposalState.Cancelled:
      return RED_COLOR;
    case ProposalState.Defeated:
      return RED_COLOR;
    case ProposalState.Succeeded:
      return GREEN_COLOR;
    default:
      return GREEN_COLOR;
  }
}

export function getColorBasedOnVotesPercentage(
  yesVotePct: number,
  noVotePct: number,
  voteThresholdPct: number
) {
  return yesVotePct >= voteThresholdPct!
    ? "#2BFAAF"
    : noVotePct! >= voteThresholdPct!
    ? "#FD2B2B"
    : "#3B4353";
}

export const getProposalStatusText = (
  proposalState: ProposalState,
  offerStatus: OfferStatus,
  hasNftSold?: boolean
) => {
  switch (proposalState) {
    case ProposalState.Voting:
      return "Voting active";
    case ProposalState.Succeeded:
      return "Voting finished - Succeeded";
    case ProposalState.Defeated:
      return "Voting finished - Defeated";
    case ProposalState.Cancelled:
      return "Proposal vetoed";
    case ProposalState.Completed:
      return offerStatus === OfferStatus.initialised
        ? "Waiting for confirmation"
        : offerStatus === OfferStatus.accepted
        ? "Trade executed"
        : offerStatus === OfferStatus.listedOnSolsea
        ? hasNftSold
          ? "NFT sold on SolSea"
          : "Listed on SolSea"
        : offerStatus === OfferStatus.executedSellOnMagicEden
        ? "NFT listed on Magic Eden"
        : offerStatus === OfferStatus.canceled ||
          offerStatus === OfferStatus.canceledOnSolsea
        ? "Trade cancelled"
        : offerStatus === OfferStatus.canceledOnMagic
        ? "Trade canceled on Magic Eden"
        : "Executed";
    default:
      return "";
  }
};
